import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';

export const InlineMessageContainer = styled.div`
  margin-left: 4px;
  display: inline-block;
  vertical-align: middle;
`;

export const StyledMessage = styled.div`
  width: calc(50vw - ${gridSize() * 6}px);
  max-width: ${gridSize() * 34}px;
  margin-left: -${gridSize()}px;
  margin-right: -${gridSize()}px;
`;

export const InputMessage = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
